import { createAction } from "redux-starter-kit";
import { normalize } from "normalizr";
import { debounce } from "lodash";

import { addEntities } from "../../entities";
import {
  FETCH_CREDIT_HISTORY_FAILURE,
  FETCH_CREDIT_HISTORY_REQUEST,
  FETCH_CREDIT_HISTORY_SUCCESS
} from "../types";

const debouncedQueryCreditReport = debounce(
  async (dispatch, schema, api, id, ordering, limit, offset, filters) => {
    dispatch(
      createAction(FETCH_CREDIT_HISTORY_REQUEST)({
        id,
        ordering,
        limit,
        offset,
        filters
      })
    );
    const response = await api.debtors.getCreditReport(
      id,
      ordering,
      limit,
      offset,
      filters
    );

    const data = normalize(response.results, [schema.creditReport]);
    dispatch(addEntities(data.entities));
    dispatch(
      createAction(FETCH_CREDIT_HISTORY_SUCCESS)({
        items: data.result,
        count: response.count
      })
    );
    return response;
  },
  1000,
  { trailing: true }
);

const queryCreditReport = (id, ordering, limit, offset, filters) => async (
  dispatch,
  getState,
  { api, schema }
) => {
  try {
    await debouncedQueryCreditReport(
      dispatch,
      schema,
      api,
      id,
      ordering,
      limit,
      offset,
      filters
    );
  } catch (err) {
    dispatch(createAction(FETCH_CREDIT_HISTORY_FAILURE)(err));
    throw err;
  }
};

export default queryCreditReport;
